'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR, INVALID_FILE_TYPE } from '../../file-uploads/constants/attachmentErrors';
import { NETWORK_OFFLINE, THREAD_HISTORY_FAILED, CREATE_NEW_THREAD_FAILED, SUBSCRIPTIONS_FAILED, PUBSUB_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED } from '../constants/networkErrors';
import AttachmentErrorAlerts from './alerts/AttachmentErrorAlerts';
import NetworkErrorAlerts from './alerts/NetworkErrorAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
class ChatAreaAlertContainer extends Component {
  render() {
    const {
      attachmentsError,
      createNewThread,
      dismissAttachmentsError,
      fetchOlderThreadHistory,
      networkError,
      resubscribe,
      selectAttachmentFile,
      startPubSub,
      thread,
      trackInteraction
    } = this.props;
    if (attachmentsError) {
      return /*#__PURE__*/_jsx(AttachmentErrorAlerts, {
        attachmentsError: attachmentsError,
        dismissAttachmentsError: dismissAttachmentsError,
        selectAttachmentFile: selectAttachmentFile,
        thread: thread,
        trackInteraction: trackInteraction
      });
    }
    if (networkError) {
      return /*#__PURE__*/_jsx(NetworkErrorAlerts, {
        createNewThread: createNewThread,
        fetchOlderThreadHistory: fetchOlderThreadHistory,
        networkError: networkError,
        resubscribe: resubscribe,
        startPubSub: startPubSub
      });
    }
    return null;
  }
}
ChatAreaAlertContainer.displayName = 'ChatAreaAlertContainer';
ChatAreaAlertContainer.propTypes = {
  attachmentsError: PropTypes.oneOf([SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR, INVALID_FILE_TYPE]),
  createNewThread: PropTypes.func.isRequired,
  dismissAttachmentsError: PropTypes.func.isRequired,
  fetchOlderThreadHistory: PropTypes.func.isRequired,
  networkError: PropTypes.oneOf([NETWORK_OFFLINE, THREAD_HISTORY_FAILED, CREATE_NEW_THREAD_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED, PUBSUB_FAILED, SUBSCRIPTIONS_FAILED]),
  resubscribe: PropTypes.func.isRequired,
  selectAttachmentFile: PropTypes.func.isRequired,
  startPubSub: PropTypes.func.isRequired,
  thread: RecordPropType('Thread').isRequired,
  trackInteraction: PropTypes.func.isRequired
};
export default ChatAreaAlertContainer;